import type { ApiClient } from '../../../api';
import type { PushPayload, PushSubscriptionBody, PushSubscriptionSaved } from '../types/domain.types';

import { CTL_ENDPOINTS } from './endpoints';
import { createCtlClient, request } from './http';
import { parseOrThrow, pushPayloadSchema, pushSubscriptionSavedSchema } from './schemas';

export const savePushSubscription = async (body: PushSubscriptionBody): Promise<PushSubscriptionSaved> => {
  const raw = await request('post', CTL_ENDPOINTS.PUSH_SUBSCRIPTIONS, { body });
  return parseOrThrow(pushSubscriptionSavedSchema, raw, 'push subscription');
};

const quietClient = createCtlClient({ onSessionLost: () => undefined });

const removeSubscriptionWith =
  (client: ApiClient) =>
  async (endpoint: string): Promise<void> => {
    await client.request('delete', CTL_ENDPOINTS.PUSH_SUBSCRIPTIONS, { body: { endpoint } });
  };

export const deletePushSubscription = removeSubscriptionWith({ request });

export const forgetPushSubscription = removeSubscriptionWith(quietClient);

export const parsePushPayload = (raw: unknown): PushPayload => parseOrThrow(pushPayloadSchema, raw, 'push payload');
